import { blackColors, whiteColor, defaultBoxShadow } from 'assets/jss/material-dashboard-pro-react';

const customTooltipStyle = (theme) => ({
	tooltip: {
		padding: 16,
		margin: 0,
	},
	info: {
		marginLeft: 18,
		color: blackColors[4],
		zIndex: 2,
		'&:hover': {
			color: blackColors[0],
		},
	},
	infoSM: {
		fontSize: theme.fontSize(20),
	},
	infoMD: {
		fontSize: theme.fontSize(24),
	},
	termsAndConditionsTooltip: {
		backgroundColor: whiteColor,
		color: blackColors[1],
		...defaultBoxShadow,
		maxWidth: 494,
		width: 494,
		[theme.breakpoints.down('sm')]: {
			maxWidth: '95vw',
		},
		'& > span': {
			// arrow
			color: whiteColor,
		},
	},
});

export default customTooltipStyle;
